// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function IrrigationSimulatorTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Irrigation Simulator</p>
      <p>
        Simulates substrate VWC over a 24-hour cycle from your substrate profile, light schedule,
        and P1/P2 irrigation programs — preview dry-back and shot timing before going live.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Select or configure a substrate profile (flow rate, emitters, container volume).</li>
          <li>Set P1 resaturation and P2 maintenance programs — shot size, count, and rest times.</li>
          <li>Run simulate and review the VWC chart, details, or export results.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Views</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Chart — 24h VWC curve with irrigation events overlaid</li>
          <li>Details — shot volumes, run times, and daily water use</li>
          <li>Saved programs — reload and compare prior room configurations</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Use with Shot Size Calculator to translate VWC targets into emitter run times.
      </p>
    </div>
  );
}
